<script>
import resources from './resources'

export default {
  name: 'accountability',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-lg-3.col-md-4.col-sm-12
    loading(
      :active.sync='isLoading',
      :can-cancel='false',
      :is-full-page='fullPage',
      color='#7159c1'
    )
    .card
      .file
        a(href='javascript:void(0);')
          div(style="float: right; padding: 10px;")
            button.btn.btn-icon.btn-icon-mini.btn-round.btn-success(
              type='button',
              @click.prevent="downloadFile(accountability)"
            )
              i.zmdi.zmdi-download
          .icon
            i.zmdi.zmdi-collection-pdf
          .file-name
            p.m-b-5.text-muted {{ accountability.description }}
            small

</template>



// WEBPACK FOOTER //
// src/app/dweller/accountability/index/components/item.vue